var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8576 0C6.2164 0 0.847656 5.40833 0.847656 12.0992C0.847656 17.4475 4.2876 21.9748 9.05971 23.5771C9.65635 23.6976 9.87489 23.3168 9.87489 22.9965C9.87489 22.716 9.85523 21.7545 9.85523 20.7527C6.51435 21.474 5.81865 19.3104 5.81865 19.3104C5.28175 17.9082 4.48623 17.5478 4.48623 17.5478C3.39277 16.8066 4.56588 16.8066 4.56588 16.8066C5.77882 16.8868 6.41528 18.0486 6.41528 18.0486C7.48884 19.8913 9.21876 19.3707 9.91472 19.0501C10.014 18.2688 10.3324 17.728 10.6704 17.4276C8.00582 17.1471 5.20234 16.1055 5.20234 11.458C5.20234 10.1359 5.67926 9.05428 6.43495 8.21304C6.31572 7.91263 5.89805 6.67043 6.55443 5.00787C6.55443 5.00787 7.56849 4.6873 9.85498 6.24981C10.8339 5.98497 11.8435 5.85024 12.8576 5.84911C13.8716 5.84911 14.9054 5.98948 15.8599 6.24981C18.1467 4.6873 19.1607 5.00787 19.1607 5.00787C19.8171 6.67043 19.3992 7.91263 19.28 8.21304C20.0556 9.05428 20.5128 10.1359 20.5128 11.458C20.5128 16.1055 17.7093 17.1269 15.0248 17.4276C15.4624 17.8081 15.84 18.5292 15.84 19.6711C15.84 21.2936 15.8204 22.5957 15.8204 22.9962C15.8204 23.3168 16.0392 23.6976 16.6355 23.5774C21.4077 21.9745 24.8476 17.4475 24.8476 12.0992C24.8673 5.40833 19.4789 0 12.8576 0Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLinkIcon);
export default __webpack_public_path__ + "static/media/github-link-icon.a3b1ad066e77710962387f844d1c049b.svg";
export { ForwardRef as ReactComponent };